import React from 'react';
import _ from 'lodash';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import SearchableSelectAll from '../../custom-widgets/SearchableSelectAll';

const normalizeSelectValue = (value, defaultValue, options) => {
    if (!value && defaultValue) return defaultValue;
    if (value && (typeof value !== 'object' || !('value' in value && 'name' in value))) {
        const matched = options?.find((opt) => opt.value === value);
        return matched ?? value;
    }
    return value;
};

const ReactHookFormSearchableSelect = ({ name, label, rules, selectProps, options, disabled, required, disableClearable, selectAll, multiple, customRender, chipLimit, variant, hideError, hideCheckbox, inputProps, defaultValue, loading, onChange: selectOnChange }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    const error = _.get(errors, name);

    return (
        <FormControl error={!!error} fullWidth>
            <Controller
                control={control}
                rules={rules}
                defaultValue={defaultValue ?? ''}
                render={({ field: { onChange, value } }) => (
                    <SearchableSelectAll
                        chipLimit={chipLimit}
                        label={label}
                        multiple={multiple}
                        selectAll={selectAll}
                        disableClearable={disableClearable}
                        required={required}
                        disabled={disabled}
                        customRender={customRender}
                        options={options}
                        onChange={(event, item) => {
                            if (selectOnChange) selectOnChange(event, item);
                            onChange(item);
                        }}
                        inputProps={inputProps}
                        value={normalizeSelectValue(value, defaultValue, options)}
                        {...selectProps}
                        variant={variant}
                        hideError={hideError}
                        hideCheckbox={hideCheckbox}
                        loading={loading}
                    />
                )}
                name={name}
            />
            {error && !hideError && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
    );
};

export default ReactHookFormSearchableSelect;
